/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Limited_CompatibilityInputs */

const en_common_limited_compatibility = /** @type {(inputs: Common_Limited_CompatibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited Compatibility`)
};

const es_common_limited_compatibility = /** @type {(inputs: Common_Limited_CompatibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilidad limitada`)
};

/**
* | output |
* | --- |
* | "Limited Compatibility" |
*
* @param {Common_Limited_CompatibilityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_limited_compatibility = /** @type {((inputs?: Common_Limited_CompatibilityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Limited_CompatibilityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_limited_compatibility(inputs)
	return en_common_limited_compatibility(inputs)
});